<div class="block flex-col gap-4 relative mb-6">

    @let loadingLessons = (loading$ | async) ?? false;
    @let lessons = (lessons$ | async) ?? [];

    <list-utils-bar [searchDisabled]="true" (onRefresh)="onRefresh()" class="w-full"></list-utils-bar>

    <div class="flex w-full flex-col gap-4">

        @for (item of lessons; track item.id) {
        <div class="bg-white shadow-lg rounded flex flex-col gap-1 w-full px-4 py-3">
            <div class="flex flex-row items-start justify-between gap-4 w-full">
                <div [routerLink]="[item.id]" [queryParams]="{ academicYear: academicYear }"
                    class="cursor-pointer flex flex-col justify-start">
                    <p class="text-primary-300 text-xs whitespace-nowrap">
                        {{ item.publishBy | moment: 'Do MMM YYYY hh:mm a' }}
                    </p>
                    <p class="font-semibold">{{ item.lessonName }}</p>
                </div>
                @if (academicYear == group?.academicYear) {
                <div class="flex flex-row gap-2 whitespace-nowrap">
                    <app-btn-fab (click)="onEdit(item)" icon="fas fa-edit" tooltip="Update Lesson"></app-btn-fab>
                    <app-btn-fab (click)="onToggleLessonStatus(item)"
                        icon="{{ item.lessonStatus == lessonStatus.closed ? 'fas fa-circle-check' : 'far fa-circle' }}"
                        textColor="{{ item.lessonStatus == lessonStatus.closed ? 'text-green-700 hover:text-primary-500' : 'text-primary-500 hover:text-green-500' }}"
                        tooltip="{{ item.lessonStatus == lessonStatus.closed ? 'Open Lesson' : 'Close Lesson' }} "></app-btn-fab>
                    <app-btn-fab (click)="onToggleLessonArchival(item, lessonStatus.archived)" icon="fas fa-file-zipper"
                        tooltip="Archive"></app-btn-fab>
                    <app-btn-fab (click)="onDelete(item)" icon="fa fa-trash-can"
                        textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                </div>
                }
            </div>
            <div class="flex flex-row justify-start items-center gap-2 mt-2">
                <app-btn-chip [label]="item.lessonStatus ?? lessonStatus.open"
                    [color]="item.lessonStatus == lessonStatus.closed ? 'text-green-700' : 'text-primary-500'"
                    [bgColor]="item.lessonStatus == lessonStatus.closed ? 'bg-green-50' : 'bg-gray-100'"></app-btn-chip>
                <app-btn-chip [label]="isLessonViewable(item.publishBy) ? 'Published' : 'Unpublished'"
                    [color]="isLessonViewable(item.publishBy) ? 'text-green-700' : 'text-primary-500'"
                    [bgColor]="isLessonViewable(item.publishBy) ? 'bg-green-50' : 'bg-gray-100'"></app-btn-chip>
            </div>
        </div>
        } @empty {
        @if(!loadingLessons) {
        <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
            No Lessons Found
        </div>
        }
        }
        @if(loadingLessons) {
        <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
            <div class="animate-pulse flex space-x-4">
                <div class="flex-1 space-y-2">
                    <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                    <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                    <div class="space-y-2">
                        <div class="grid grid-cols-3 gap-4 mb-2">
                            <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                            <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div class="flex flex-row gap-2 justify-start items-center">
                            <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                            <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
    <div class="flex flex-row w-full justify-center px-4 mt-3">
        <app-btn-more (click)="addMore()"
            [isDisabled]="loadingLessons || user?.uid == null || groupId == null"></app-btn-more>
    </div>
</div>